import React from 'react';
import { useEffect } from 'react';
import hooks from "./hooks";
// @ts-ignore
var TCaptcha = function TCaptcha(props) {
  var fail = props.fail,
    depend = props.depend,
    serverVerify = props.serverVerify,
    children = props.children,
    _props$autoOpenVerify = props.autoOpenVerify,
    autoOpenVerify = _props$autoOpenVerify === void 0 ? false : _props$autoOpenVerify,
    _props$skipVerify = props.skipVerify,
    skipVerify = _props$skipVerify === void 0 ? false : _props$skipVerify;
  var myHooks = hooks(serverVerify, fail);
  var afterServerVerify = myHooks.afterServerVerify,
    loadScript = myHooks.loadScript,
    doVerify = myHooks.doVerify,
    destroyCaptcha = myHooks.destroyCaptcha;
  var finialChildren = React.Children.map(children, function (childItem) {
    afterServerVerify(childItem.props.onClick);
    return /*#__PURE__*/React.cloneElement(childItem, {
      onClick: function onClick() {
        if (depend) {
          var form = depend.form,
            key = depend.key;
          form.validateFields([key]).then(function () {
            doVerify();
          });
        } else {
          doVerify();
        }
      }
    });
  });
  useEffect(function () {
    loadScript(autoOpenVerify);
    return function () {
      // 销毁图形验证码
      destroyCaptcha();
    };
  }, []);
  // 如果开启了是否跳过滑动验证码 就直接渲染children
  var renderDom = skipVerify ? children : finialChildren;
  return renderDom;
};
export default TCaptcha;